/**
 * BriqueChart의 Mode Bar의 버튼과 관련된 Event 처리
 */

import { BRIQUECHART_LEGEND_POSITIONS, BRIQUECHART_TOOLTIP_MODES } from './BriqueChartConst'

import BriqueChart from './BriqueChart.vue'
import Plotly from 'plotly.js-dist'
import { ToastProgrammatic as Toast } from 'buefy'

export default {
  /**
   * Copy image to clipboard 클릭 이벤트
   * @param {Object} btn 버튼 객체
   * @param {Object} element Chart Element
   * @param {Object} e 이벤트 객체
   */
  onClickCopyImageToClipboard (btn, element, e) {
    BriqueChart.restyleModeBarButtons(element)
    Plotly.toImage(element, { 'height': element.clientHeight, 'width': element.clientWidth }).then(async function (url) { // url : data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAB
      const blob = await fetch(url).then(res => res.blob())

      try {
        await navigator.clipboard.write([new ClipboardItem({ 'image/png': blob })])
        Toast.open({
          message: element.parentElement.__vue__.$t('fdc.CHART_COMPONENT.MESSAGE.SUCCEED_COPY_CHART_IMAGE'),
          type: 'is-success',
          queue: false // queue: false => toast가 2개 이상일 때 같은 영역에 덮어쓰지 않고, 최신것이 위에 표시되게 하는 방식
        })
      } catch (e) {
        console.log(e)
        Toast.open({
          message: element.parentElement.__vue__.$t('fdc.CHART_COMPONENT.MESSAGE.FAILED_COPY_CHART_IMAGE'),
          type: 'is-warning',
          queue: false // queue: false => toast가 2개 이상일 때 같은 영역에 덮어쓰지 않고, 최신것이 위에 표시되게 하는 방식
        })
      }
    })
  },

  /**
   * Mode Bar에서 툴팁 모드 클릭 이벤트
   * @param {Object} btn 버튼 객체
   * @param {Object} element Chart Element
   * @param {Object} e 이벤트 객체
   */
  onClickTooltipMode (btn, element, e) {
    BriqueChart.restyleModeBarButtons(element)
    if (_.isString(element)) element = document.querySelector(`#${element}`)

    // 3 Toggle
    let briqueChartOption = element.briqueChartOption
    let index = BRIQUECHART_TOOLTIP_MODES.indexOf(briqueChartOption.tooltip.mode)
    briqueChartOption.tooltip.mode = BRIQUECHART_TOOLTIP_MODES[(index + 1) % BRIQUECHART_TOOLTIP_MODES.length] // 3 toggle
    BriqueChart.applyTooltipMode(element)
  }, // end - onClickTooltipMode

  /**
   * Mode Bar에서 Compare data on hover 클릭 이벤트
   * @param {Object} btn 버튼 객체
   * @param {Object} element Chart Element
   * @param {Object} e 이벤트 객체
   */
  async onClickHoverCompareCartesian (btn, element, e) {
    BriqueChart.restyleModeBarButtons(element)
    let strContents = ''
    let xAxisTextElement = element.querySelector(`.hoverlayer .axistext text`)
    let xAxisText = xAxisTextElement?.textContent
    if (!_.isEmpty(xAxisText)) {
      strContents = xAxisText
    }

    let yHoverElements = element.querySelectorAll(`.hoverlayer .hovertext`)
    for (let hoverElement of yHoverElements) {
      let yTextElements = hoverElement.querySelectorAll(`text`)

      // 첫번째 것이 범례이고
      if (yTextElements.length > 0) {
        if (strContents.length !== 0) strContents += '\r\n'
        strContents += yTextElements[0].textContent
      }

      // 두번째 것이 Value이다.(prefix 포함)
      if (yTextElements.length > 1) {
        if (strContents.length !== 0) strContents += '\n'
        var oriText = yTextElements[1].dataset.unformatted.replace('<br>', '\n')
        var newText = oriText.replace(/(<([^>]+)>)/ig, '')
        strContents += newText
        strContents += '\n'
        // strContents += yTextElements[1].textContent
      }
    }

    if (_.isEmpty(strContents)) {
      Toast.open({
        message: element.parentElement.__vue__.$t('fdc.CHART_COMPONENT.MESSAGE.INFORM_TRY_AGAIN_COPY_TOOLTIP'),
        type: 'is-warning',
        queue: false // queue: false => toast가 2개 이상일 때 같은 영역에 덮어쓰지 않고, 최신것이 위에 표시되게 하는 방식
      })

      return
    }

    try {
      await navigator.clipboard.writeText(strContents)
      Toast.open({
        message: element.parentElement.__vue__.$t('fdc.CHART_COMPONENT.MESSAGE.SUCCEED_COPY_TOOLTIP'),
        type: 'is-success',
        queue: false // queue: false => toast가 2개 이상일 때 같은 영역에 덮어쓰지 않고, 최신것이 위에 표시되게 하는 방식
      })
    } catch (e) {
      console.log(e)
      Toast.open({
        message: element.parentElement.__vue__.$t('fdc.CHART_COMPONENT.MESSAGE.FAILED_COPY_TOOLTIP'),
        type: 'is-warning',
        queue: false // queue: false => toast가 2개 이상일 때 같은 영역에 덮어쓰지 않고, 최신것이 위에 표시되게 하는 방식
      })
    }
  },

  /**
   * Mode Bar에서 범례 위치 변경 클릭 이벤트
   * @param {Object} btn 버튼 객체
   * @param {Object} element Chart Element
   * @param {Object} e 이벤트 객체
   */
  onClickChangeLegendPosition (btn, element, e) {
    BriqueChart.restyleModeBarButtons(element)
    if (_.isString(element)) element = document.querySelector(`#${element}`)

    // 5 Toggle
    let briqueChartOption = element.briqueChartOption

    let index = BRIQUECHART_LEGEND_POSITIONS.findIndex(o => o.val === briqueChartOption.legend.position)

    let next = BRIQUECHART_LEGEND_POSITIONS[(index + 1) % BRIQUECHART_LEGEND_POSITIONS.length]
    briqueChartOption.legend.position = next.val // 5 toggle

    BriqueChart.setLayoutFromLegendPosition(element, element.layout, briqueChartOption)
    BriqueChart.relayout(element, element.layout, true).then(() => {
      BriqueChart.restyleLegend(element)

      let msg = element.parentElement.__vue__.$t('fdc.CHART_COMPONENT.MESSAGE.INFORM_LEGEND_BOTTOM')
      switch (next.val) {
        case 'bottom':
          msg = element.parentElement.__vue__.$t('fdc.CHART_COMPONENT.MESSAGE.INFORM_LEGEND_BOTTOM')
          break
        case 'left':
          msg = element.parentElement.__vue__.$t('fdc.CHART_COMPONENT.MESSAGE.INFORM_LEGEND_LEFT')
          break
        case 'top':
          msg = element.parentElement.__vue__.$t('fdc.CHART_COMPONENT.MESSAGE.INFORM_LEGEND_TOP')
          break
        case 'right':
          msg = element.parentElement.__vue__.$t('fdc.CHART_COMPONENT.MESSAGE.INFORM_LEGEND_RIGHT')
          break
        case 'none':
          msg = element.parentElement.__vue__.$t('fdc.CHART_COMPONENT.MESSAGE.INFORM_LEGEND_NONE')
          break
      }

      Toast.open({
        message: msg,
        type: 'is-success',
        queue: false // queue: false => toast가 2개 이상일 때 같은 영역에 덮어쓰지 않고, 최신것이 위에 표시되게 하는 방식
      })
    })
  }, // end - onClickChangeLegendPosition

  /**
   * Sampling Data 클릭 이벤트
   * @param {Object} btn 버튼 객체
   * @param {Object} element Chart Element
   * @param {Object} e 이벤트 객체
   */
  onClickSamplingData (btn, element, e) {
    BriqueChart.restyleModeBarButtons(element)
    BriqueChart.toggleModeBarButtonActive(element, btn)
    let layout = element.layout

    if (btn.active) {
      BriqueChart.samplingDataDebounce(element, layout.xaxis.range[0], layout.yaxis.range[0], layout.xaxis.range[layout.xaxis.range.length - 1], layout.yaxis.range[layout.yaxis.range.length - 1], true)
      BriqueChart.setModeBarTitle(element, btn, element.parentElement.__vue__.$t('fdc.CHART_COMPONENT.MESSAGE.INFORM_SHOW_SAMPLING_DATA'))
    } else {
      BriqueChart.resetSamplingData(element, true)
      BriqueChart.setModeBarTitle(element, btn, element.parentElement.__vue__.$t('fdc.CHART_COMPONENT.MESSAGE.INFORM_SHOW_ALL_DATA'))
    }
  }, // end - onClickSamplingData

  /**
   * Range View 클릭 이벤트
   * @param {Object} btn 버튼 객체
   * @param {Object} element Chart Element
   * @param {Object} e 이벤트 객체
   */
  async onClickRangeView (btn, element, e) {
    BriqueChart.restyleModeBarButtons(element)

    BriqueChart.toggleModeBarButtonActive(element, btn)
    BriqueChart.setLayoutFromLegendPosition(element, element.layout, element.briqueChartOption)

    if (btn.active) {
      let layout = element.layout
      layout.xaxis.rangeslider = {}

      await BriqueChart.relayout(element, layout, true)

      let seriesindices = element.briqueChartOption.xaxis.rangeslider.seriesIndices

      if (!_.isEmpty(seriesindices)) {
        let rangeSeriesElements = element.querySelectorAll(`.rangeslider-container .rangeslider-rangeplot .plot .rangeplot .trace`)
        for (let e of rangeSeriesElements) {
          e.style.display = 'none'
        }

        for (let i of seriesindices) {
          let uid = element._fullData[i].uid
          let seriesRangeElement = element.querySelector(`.rangeslider-container .rangeslider-rangeplot .plot .rangeplot .trace${uid}`)
          if (seriesRangeElement) { // 확대가 되는 경우 Range View에 표시안되는 Series가 있을 수 있다.
            seriesRangeElement.style.display = 'inline'
          }
        }
      }

      Toast.open({
        message: element.parentElement.__vue__.$t('fdc.CHART_COMPONENT.MESSAGE.INFORM_SHOW_RANGE_VIEW'),
        type: 'is-success',
        queue: false // queue: false => toast가 2개 이상일 때 같은 영역에 덮어쓰지 않고, 최신것이 위에 표시되게 하는 방식
      })
    } else { // Range View Off
      element.layout.xaxis.rangeslider = undefined
      await BriqueChart.relayout(element, element.layout, true)

      Toast.open({
        message: element.parentElement.__vue__.$t('fdc.CHART_COMPONENT.MESSAGE.INFORM_HIDE_RANGE_VIEW'),
        type: 'is-success',
        queue: false // queue: false => toast가 2개 이상일 때 같은 영역에 덮어쓰지 않고, 최신것이 위에 표시되게 하는 방식
      })
    }
    // if (element.briqueChartOption.legend.position === 'bottom') {
    //   // Legend의 위치를 다시 계산한다
    //   BriqueChart.setLayoutFromLegendPosition(element, element.layout, element.briqueChartOption)
    //   Plotly.relayout(element, element.layout, true)
    // }
  }, // end - onClickRangeView

  /**
   * 데이터 정규화 클릭 이벤트
   * @param {Object} btn 버튼 객체
   * @param {Object} element Chart Element
   * @param {Object} e 이벤트 객체
   */
  onClickDataNormalization (btn, element, e) {
    BriqueChart.restyleModeBarButtons(element)

    BriqueChart.toggleModeBarButtonActive(element, btn)
    BriqueChart.setLayoutFromLegendPosition(element, element.layout, element.briqueChartOption)

    if (btn.active) {
      BriqueChart._dataNormalization(...arguments)
    } else {
      BriqueChart._releaseDataNormalization(...arguments)
    }
  },

  /**
   * 데이터 정규화
   * @param {Object} btn 버튼 객체
   * @param {Object} element Chart Element
   * @param {Object} e 이벤트 객체
   */
  _dataNormalization (btn, element, e) {
    element.briqueChartData.isDataNormalization = true
    let ori = element.briqueChartData.tracesOriginal

    let traces = _.cloneDeep(ori)

    ori.map((trace, i) => {
      let max = trace.y.reduce((maxY, y) => {
        if (isNaN(y)) return maxY
        if (isNaN(maxY)) return y
        return y > maxY ? y : maxY
      }, trace.y[0])

      let min = trace.y.reduce((minY, y) => {
        if (isNaN(y)) return minY
        if (isNaN(minY)) return y
        return y < minY ? y : minY
      }, trace.y[0])

      let diff = max - min
      traces[i].y = trace.y.map(y => {
        return (y - min) / diff
      })

      element.briqueChartData.setSeriesStyle(trace.name, { mode: trace.mode }) // 차트 종류 원복
    })

    if (element.briqueChartData.isXAsixDataSelection) {
      element.briqueChartData.isXAsixDataSelection = false
      BriqueChart.setXMinMax(element, traces, undefined, true)
    }

    BriqueChart.setYMinMax(element, traces)

    element.briqueChartData.tracesOriginalAfterXAxisDataSelection = _.cloneDeep(traces)
    if (element.briqueChartData.isSampling) {
      traces = BriqueChart.getSamplingData(element).traces
    }

    BriqueChart.react(element, traces)

    Toast.open({
      message: element.parentElement.__vue__.$t('fdc.CHART_COMPONENT.MESSAGE.INFORM_NORMALIZATION_DATA'),
      type: 'is-success',
      queue: false // queue: false => toast가 2개 이상일 때 같은 영역에 덮어쓰지 않고, 최신것이 위에 표시되게 하는 방식
    })
  },

  /**
   * 데이터 정규화 해제
   * @param {Object} btn 버튼 객체
   * @param {Object} element Chart Element
   * @param {Object} e 이벤트 객체
   */
  _releaseDataNormalization (btn, element, e) {
    // X측 데이터 선택 초기에 동작 안함
    // X축 데이터 선택하면... Nomalization 해제할 것
    // Nomalization 설정하면 X축 데이터 선택 해제할 것(Modal Data 초기화 필요)

    element.briqueChartData.isDataNormalization = false
    let ori = element.briqueChartData.tracesOriginal
    let traces = _.cloneDeep(ori)

    element.briqueChartData.tracesOriginalAfterXAxisDataSelection = _.cloneDeep(traces)

    if (element.briqueChartData.isXAsixDataSelection) {
      element.briqueChartData.isXAsixDataSelection = false
      BriqueChart.setXMinMax(element, traces, undefined, true)
    }

    BriqueChart.setYMinMax(element, traces)

    if (element.briqueChartData.isSampling) {
      traces = BriqueChart.getSamplingData(element).traces
    }

    BriqueChart.react(element, traces)

    Toast.open({
      message: element.parentElement.__vue__.$t('fdc.CHART_COMPONENT.MESSAGE.INFORM_NORMALIZATION_DATA_CANCEL'),
      type: 'is-success',
      queue: false // queue: false => toast가 2개 이상일 때 같은 영역에 덮어쓰지 않고, 최신것이 위에 표시되게 하는 방식
    })
  },

  /**
   * Export Csv Data
   * @param {*} element
   */
  onClickExportCsv (element) {
    element.briqueChartData.setCsvData(element)
  }
}
